import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { DisclaimerReview } from "../types/panel.type";

export const useReviewDisclaimer = (rfxId: number, evalId: number) => {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (params: { memberId: number; payload: DisclaimerReview }) =>
			apiV2.put(
				`/rfx/${rfxId}/evaluation/${evalId}/panel-members/${params.memberId}/disclaimer/review`,
				params.payload
			),
		onSuccess: () => {
			// Match the panel query keys used by the member table
			// (panelKeys.all → ["evaluation-panel", rfxId, evalId, ...]).
			// The previous ["panel-members"] key matched nothing, so the table
			// stayed stale until a manual refetch / tab change.
			qc.invalidateQueries({
				queryKey: ["evaluation-panel", rfxId, evalId],
			});
		},
	});
};
